import services from './../../../services/service'; // Service Class
import GalleryForm from './../../posts/newgallery.vue'; // Add Gallery
import ProductGalleryForm from './../../posts/newproductgallery.vue'; // Add Product Gallery
import Chat from './../../templates/chat/index.vue'; // Chat 

let service = new services();
//prefix == postsco
export default {
    name: 'PostsCo',
    props: {},
    mixins: [Chat],
    data () {
        return {
            user:{},
            market:{},
            sellpoint:{},
            categories:{},
            galleria:{},
            gallery:{},
            gallery_post:{},
            gallery_post_set_image:{},
            products: {},
            product: {},
            productMain:{},
            productItem:{},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn:false,
            edit_mode:false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item:{},
            swipe_index: 0, // two way

            data_error_message: "",
            data_success_message: "",
            data_processing_message:"",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            
            addPanel:false,
            business_load_error_msg:"",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks:0,
            max_plan_lookbook_posts:0,
            total_lookbooks_added:0,
            can_add_more_lookbook:false,
            can_add_product_lookbook:false,
            refresh_button:false,
            disable_btn:false,
            action_loading:false,
            default_banner_image:"https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            set_sellpoint_banner_image: '',

            gallery_view:false,
            //mobil-swipe-handle .1
           //index:0, //two way

            //mobil-swipe-handle .2.
           swiperOption: {
            pagination: {
                el: '.swiper-pagination'
            }
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev'
            // }
          },
          menu_view:{},
          menu_tab_view:{},
        //   chat_logs:{},
        //   chat_log:{},
        //   chat:{},
        //   active_chat:{},
          //
          business_posts:{},

          //commatty
          com:{},
          comlogs:{},
          com_member:{},
          group:{},
          groups:{},
          post:{},
          posts:{},
          post_as:{},
          file_info: {},
          files_info:[], //muttiple files
          imageForm: "",
          imagesFormArray: [], //multiple files
          selected_group_members: [],
        }
    },
  
  
    components: {
        'add-lookbook': GalleryForm,
        'add-product-lookbook': ProductGalleryForm,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        ///
        setMenuComponent(view){
            this.menu_view = {};
            this.menu_view[view] = true;
            //unactivate
            var tabs = document.getElementsByClassName('tab-menu-link');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].style = "color:#000000;";
            } 
            document.getElementById(view).style.color = service.app_default_color;
            // if(view == "categories"){document.getElementById("m_categories").style.color = "#ff0066";}
            // if(view == "products"){document.getElementById("m_products").style.color = "#ff0066";}
            // if(view == "reviews"){document.getElementById("m_reviews").style.color = "#ff0066";}
        },

        setMenuTabView(view){
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        checkIfVideo(url){
            if(url != undefined){
                let ext = url.split('.').pop();
                if(service.video_exts.includes(ext)){
                    return true;
                }else{
                    return false;
                }
            }
        },

        addComponent(attr1,attr2){
           
            this.addPanel = true;
                
            if(attr1 == "add-new-lookbook"){
                this.newLookbookForm = true;
            }
            if(attr1 == "add-new-product-lookbook"){
                this.newProductLookbookForm = true;
            }
            if(attr1 == "add-new-product-post"){
                //change this url to accomodate product
                this.$router.push("/"+this.$route.params.id+"/"+this.gallery.gallery_posts_group_url_name)
               // $('#quickviewModal').modal('hide');
                //then call
                this.newProductLookbookForm = true;
            }
            if(attr1 == "add-new-post"){
                this.addNewPost = true;
               // $('#quickviewModal').modal('hide');
                this.gallery = attr2;

            }
            
            //ifopen sidebar if closed and gallery_view is on turn off
            if(this.gallery_view){
                //turn off
                this.gallery_view = false;
                //open side bar
                // this.mobileSideNavToggle("open");
                let self = this;
                setTimeout(function(){ self.mobileSideNavToggle("open"); }, 150)
            }

            //make page to jump to specific location
            // document.getElementById("addPanelView").scrollIntoView(); //general addPanelView otherwise use specific names

            //BETTER - srolls to the very top
            var top = document.getElementById("addPanelView").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
        },

        setComponent(attr1,attr2){
            if(attr1 == "refresh-store"){
                this.getGalleryPosts();
            }
            if(attr1 == "close-gallery-view"){
                this.gallery_view = false;
            }
        },

        reset(){
            // document.getElementById("yuyu").style.width = "300px";
            this.addPanel = false,
            this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        
        preset() {
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    // self.is_editing();
                    self.getChatLogs();//run first
                    self.getChatLog();//run first
                    self.loadComLogs();

                    //preset com_member details
                    self.com_member.com_member_id = self.user.user_id;
                    self.com_member.com_member_name = self.user.user_name;
                    self.com_member.com_member_type = 2;
                    self.post_as = self.com_member;
                    // setTimeout(function(){ 
                        
                    // }, 30000);
                    // self.getChatLogs();

                    self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
        },

        is_editing(){ //preseting if seller
            if(this.user.user_id != ""){
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                }
                service.can_edit(this, payload).then(response => {
                    if(response.body.status == 200) {
                        this.edit_mode =  true;
                        // this.can_edit = true;
                    }else {
                        this.edit_mode =  false;
                    }
                }).catch((err) => {
                    if(err) {
                        //log error
                    }
                })
            }
        },

        //...commat

        loadComLogs(){
            this.activate_processing();
            service.getComLogs(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.comlogs = response.body.data;
                    this.deactivate_processing();
                }
            }).catch((err) => {})
        },

        loadComPosts(){
            this.activate_processing();
            if(this.com.com_type == 4){ //get group posts
                service.getXPostsGroups(this, this.com.com_type_id,0,50).then(response => {
                    if(response.body.status == 200) {
                        this.posts = response.body.data;
                        this.deactivate_processing();
                    }else{this.deactivate_processing();}
                }).catch((err) => {this.deactivate_processing(); })
            }else{
                service.getXPosts(this, this.com.com_type, this.com.com_type_id,0,50).then(response => {
                    if(response.body.status == 200) {
                        this.posts = response.body.data;
                        this.deactivate_processing();
                    }else{this.deactivate_processing();}
                }).catch((err) => {this.deactivate_processing(); })
            }
        },

        setComView(com){
            this.com = com;
            this.setMenuTabView('comView');
            this.loadComPosts();
        },

        setComPost(post){
            this.post = post;
            this.setMenuTabView('comPostView');

        },

       
         
        createNewGroup(){
            this.activate_processing();
            var payload = {
                group_name: this.group.group_name,
                group_description: this.group.group_description,
                group_module: this.group.group_module || 0,
                group_module_id: this.group.group_module_id || 0,
                group_created_by: this.user.user_id,
            }
            let navi = this.$router;
            if((payload.group_name != undefined) || (payload.group_name != '')) {
                service.createNewGroup(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Created";
                        this.loadComLogs();
                        this.deactivate_processing();
                        this.setMenuTabView('viewLogs');
                        this.setMenuComponent('welcomeView');
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        selectGroupMembers(com){
            const indexa = this.selected_group_members.findIndex(cm => cm.com_ref === com.com_ref); //best removal
            if(indexa >= 0){
                this.selected_group_members.splice(indexa, 1);
            }else{
                this.selected_group_members.push(com);
                this.selected_group_members[0].com_group = 0;
            }
        },

        addNewGroupMembers(members_set){
            var payload_arr = [];
            for(let m of members_set){

                var payload = {
                    group_member_group: m.member_group || 0,
                    group_member_group_module: m.member_group_module || 0, //used to get group id if group was not specified
                    group_member_group_module_id: m.member_group_module_id || 0,
                    group_member_type: m.member_type || 0,
                    group_member_module: m.member_module || 1,
                    group_member: m.member_id || 0,
                }
                payload_arr.push(payload);
            }
            let navi = this.$router;
            if(Object.keys(payload_arr).length > 0) {
                service.addMembersToGroups(this, payload_arr).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Members addded";
                        this.deactivate_processing();
                    }
                }).catch((err) => {})
            }else{
                this.data_processing_message = 'Something may have went wrong';
                this.deactivate_processing();
            }
        },

        addMembersToGroup(){
            this.activate_processing();
            var payload_arr = [];
            for(let m of this.selected_group_members){
                let com_module = 1; //default-users
                if(m.com_type == 2){
                    com_module = 3; //businesses
                }else if(m.com_type == 3){
                    com_module = 1; //users
                }
                var payload = {
                    group_member_group: this.com.com_type_id, //ie 
                    group_member_type: m.com_type,
                    group_member_module: com_module,
                    group_member: m.com_type_id || 0,
                }
                
                payload_arr.push(payload);
            }
            let navi = this.$router;
            if(this.selected_group_members.length > 0) {
                service.addMembersToGroups(this, payload_arr).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Members addded";
                        this.setMenuTabView('comView');
                        this.selected_group_members = [];
                        this.deactivate_processing();
                    }
                }).catch((err) => {})
            }else{
                this.data_processing_message = 'Something may have went wrong';
                this.deactivate_processing();
            }
        },

        
        addNewPost(){
            this.activate_processing();
            //some checks
            if(this.post.post_products.length > 0){this.post_has_products = 1;}else{this.post_has_products = 0;}
            //default sets
            let post_group = 0;
            if(this.com.com_type == 4){ //group p0st
                post_group = this.com.com_type_id;
            }
            var payload = {
                post_point_type: this.com_member.com_member_type,
                post_point: this.com_member.com_member_id,
                post_group: post_group,
                post_user: this.user.user_id,
                post_type: this.post.post_type,
                post_parent: 0,
                post_title: this.post.post_title || "nil",
                post_post: this.post.post_details || "nil",
                post_start_date: this.post.post_start_date || "",
                post_end_date: this.post.post_end_date || "",
                post_product: this.post.post_product || 0,
                post_has_products: this.post_has_products || 0,
                post_products: this.post.post_products || [],
            }
          
            let navi = this.$router;
            if((payload.post_details != undefined) || (payload.post_details || 'nil')) {
                service.addXPosts(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Post Created";
                        //log user in
                        let response_post = data.body.data;
                        this.posts = data.body.data_posts;
                           
                        //add image //images //media  //multilple uploads loops
                        let uploads_count = 0;
                        if(this.imagesFormArray.length > 0){
                            for(let imageForm of this.imagesFormArray){
                                imageForm.append("data_id", response_post.post_id);
                                imageForm.append("data_type","post_media");
                                service.uploadDataPhoto(this, imageForm).then(data => {
                                    if(data.body.status == 200){
                                        uploads_count++;
                                        if(uploads_count == this.imagesFormArray.length){
                                            this.setMenuTabView('comView');
                                            this.setMenuComponent('welcomeView')
                                            this.deactivate_processing();
                                        }
                                    }
                                }).catch((err) => {
                                    this.data_processing_message =  "Media upload may have a problem";
                                    this.deactivate_processing();
                                })
                            }
                        }else{
                            this.setMenuTabView('comView');
                            this.setMenuComponent('welcomeView')
                            this.deactivate_processing();
                        }
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        onFileChangeMultiplePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length > 0)
            {   
                this.files_info = files;
                for(let file of files){
                    let formData = new FormData();
                    formData.append('photo', file); 
                    this.imagesFormArray.push(formData);
                }
            } 
        },

        //..commat

        setGallery(){
            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                    this.gallery = response.body.data;

                    // this.preset();
                    this.loading = false;
                }
            }).catch((err) => {
               // console.log(err)
             //   this.redir(this.$route.params.id1); //go to sellpoint
                //log it
                //location.replace("/")
            })
        },

      
        setMarket(){ 
            this.loading = true;
            service.getMarketActivityProducts(this, service.market_app_name, 0, 50).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data; 
                    this.preset();
                }
            }).catch((err) => {
                this.loading = false;
                //move
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        setSellpoint(){ 
            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    this.preset();
                    document.title = this.sellpoint.business_name + " | " + service.app_name;
                    //this.getProductsInBusinessCategories(); // if basic sellpoint
                    this.getSellpointProducts(); // if basic sellpoint
                    this.getSellpointPosts(); //
                    //store or restore in localforage

                    //set the banner image 
                    if((this.sellpoint.business_banner_image == this.default_banner_image) || (this.sellpoint.business_banner_image == 'error')){
                        //assign market general banner image
                        //this.set_sellpoint_banner_image = service.general_banner_image; //use default inline color for now //for fast loading till //reset
                        this.set_sellpoint_banner_image = service.general_banner_image; 
                    }else{
                        //use the sellpoints banner image
                        this.set_sellpoint_banner_image = this.sellpoint.business_banner_image;
                    }
                    
                    
                }else{
                    this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch((err) => {
                this.loading = false;
                //move
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        getSellpointProducts(){
            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        getSellpointPosts(){
            this.loading = true;
            service.getXPosts(this, 2, this.sellpoint.business_id, 0, 50).then(response => {
                if(response.body.status == 200) {
                    this.business_posts = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        getProductsInBusinessCategories(){
            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) { 
                    this.categories = response.body.data;
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        //followings

        followSellpoint(){
            this.activate_processing();
            var payload = {
                following_user: this.user.user_id,
                following_type: 1, //business
                following_module: 3, //business
                following_module_id: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if((payload.following_module != undefined)) {
                service.addFollowing(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Followed";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }

        },


        followPost(post){
            this.activate_processing();
            var payload = {
                following_user: this.user.user_id,
                following_type: 3, //event
                following_module: 6, //post
                following_module_id: post.post_id,
            }
          
            let navi = this.$router;
            if((payload.following_module != undefined)) {
                service.addFollowing(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Followed";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }

        },

        //posts
        setNewPost(post_type,post_type_name){
            this.post = {}; //refresh
            this.post.post_products = []; //initialise
            this.post.selected_post_products = []; //initialise //for hold
            this.post.post_temp_id = Math.random(); //for temp purposes
            this.post.post_type = post_type;
            this.post.post_type_name = post_type_name;
            this.setMenuComponent("newPosts");
        },
        postComment(){

        },

        //chats
        //---mixins::Chat    
        //chats

        //gallery
        getGalleryPosts(){
            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id,0,this.max_plan_lookbooks,0,this.max_plan_lookbook_posts).then(response => {
                // if(response.body.status != 400) {
                    this.galleria = response.body.data;
                    //settings
                    this.total_lookbooks_added = response.body.total_data;

                    if(this.total_lookbooks_added < this.max_plan_lookbooks){
                        this.can_add_more_lookbook = true;
                    }
                //}
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
            })
        },

        getPostsInGallery(gallery){
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];
            // this.gallery_post_set_image = gallery.gallery_posts_group_posts[0].gallery_post_media;
            
            if(this.gallery_post.gallery_post_media[0]){
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            }else{
                this.gallery_post_set_image = {};
            }
            // this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            
            
            this.gallery_view = true;
            //  setTimeout(function(){ 
            //     var top = document.getElementById("galleryview").offsetTop; 
            //     window.scrollTo(0, top); 
            // }, 400);
            // $('#quickviewModal').modal('show');
        },
      
        getCategoryProducts(category){
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
            
        },

        getCategoryProductsXX(category){
            this.loading = true;
            let self = this;
            service.getCategoryProducts(this, category).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    // this.product = this.products;
                    
                    // this.viewAllProductsBanner = true;
                    // this.showSidebarMobile = false;
                    //ist one
                    let count = 0;
                    this.products.forEach(element => {
                        count++;
                        if(count == 1){
                            this.product = element;
                            $('#quickviewModal').modal('show');
                        }
                       
                    });
                    this.loading = false;
                }
            }).catch((err) => {
                this.loading = false;
            })
        },

        showPost(post){
            this.gallery_post = post;
            
            // this.gallery_post_set_image = post.gallery_post_media[0];

            if(this.gallery_post.gallery_post_media[0]){
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            }else{
                this.gallery_post_set_image = {};
            }
        },
       
        showPostImage(post_image){
            this.gallery_post_set_image = post_image;
        },
        
        showProduct(product){
            this.product = product;
        },

        addPostToGallery(){
            this.activate_processing();
            // this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id, 
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Post Created";
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                            if(data.body.status == 200){
                            location.reload(true);
                            this.gallery = data.body.data_gallery;
                            this.addNewPost = false;
                            }
                            this.deactivate_processing();
                        }).catch((err) => {
                                if(err) {
                                // log it
                                //console.log(err)
                                }
                            //toastr.warning("Something went wrong.", 'Warning!');
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        })
                        //if uploading takes time continue with reload
                        let self = this;
                        setTimeout(function(){  location.reload(true); }, 2000); //wait for 1min and timeout

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                       // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong";
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

        onFileChangeBannerImage(e,type) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id); 
                formData.append('data_type', type); 
                service.uploadBusinessDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "business_banner_image"){
                            this.sellpoint.business_banner_image = data.body.data;
                            this.set_sellpoint_banner_image = this.sellpoint.business_banner_image;
                        }
                        if(type == "business_brand_image"){
                            this.sellpoint.business_brand_image = data.body.data;
                        }
                        //wait and reset
                        let self = this;
                        setTimeout(function(){ 
                            //close the sidebar after one sec
                            self.deactivate_processing();
                            self.mobileSideNavToggle('close');
                            //load a bit more to set the image
                            self.loading = true;
                            setTimeout(function(){ 
                                self.loading = false;
                            }, 1200);
                        }, 1000);
                        // this.deactivate_processing();
                    }else{
                        this.data_error_message = "Could not update, something went wrong. Please try again";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_error_message = "Could not update, something went wrong. Please try again";
                    this.deactivate_processing();
                })
            }   
                
        },

        manageLookbook(){
            this.disable_btn = true;
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username+'/g/'+this.gallery.gallery_posts_group_url_name,
            } 
            if(credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        //redirect to sp with session ref
                        let ref = response.body.data;
                        window.location.href = service.sp_url+'/manage/'+ref;
                    }else{
                        this.disable_btn = false;
                    }
                }).catch((err) => {
                    if(err) {
                       // console.log(err)
                        this.disable_btn = false;
                       // this.$router.push('/login/');
                    }
                })
            }
        },

        placeOrder(product,product_item){
            this.ordered_product = product;
            this.ordered_product_item =  product_item;
            this.place_order = true;
        },

        resetOptions(){
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        //../gallery

        

        //mobil-swipe-handle
        handleResize() {
            this.$refs.swipe.reset();
        },

        //callables
        postsco_callCreateNewGroup(group){
            this.group = group;
            this.createNewGroup();
        },

        postsco_callAddNewGroupMembers(data){
            this.addNewGroupMembers(data);
        },
        
    },
  
    created: function(){
        this.menu_view["welcomeView"] = true;
        this.menu_tab_view["viewLogs"] = true;
        this.preset();
        // this.setMarket();
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/postsco/script.js